import { Accordion, ShadowContainer, Text } from "basis";
import { useEventTracking } from "react-event-tracker";

function WaysToPayFAQ() {
  const { trackEvent } = useEventTracking();
  return (
    <ShadowContainer
      shadowSize="none"
      shadowSize-md="tiny"
      shadowContrast="medium"
      padding="4"
    >
      <Text textStyle="heading5" margin="0 0 4 0">
        Frequently asked questions
      </Text>
      <Accordion
        onItemToggle={({ isOpen, itemHeaderChildren }) => {
          if (isOpen) {
            trackEvent({
              event: {
                category: "accordion",
                action: "in-page-navigation",
                location: "Frequently asked questions",
                label: itemHeaderChildren,
              },
            });
          }
        }}
      >
        <Accordion.Item>
          <Accordion.Item.Header>What does overdue mean?</Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              Being overdue is when you have missed any part of your minimum
              payment by the due date. In order to avoid late fees, you need to
              pay any amount that is due and payable (e.g. your minimum monthly
              payment) by the due date. If you are overdue or overlimit you need
              to pay the 'Due immediately' amount straight away.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Item.Header>
            What does overdue or overlimit with minimum payment mean?
          </Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              Payments may take up to 3 days to clear and that’s why we
              recommend combining overdue or overlimit with your minimum
              payment.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Item.Header>
            What does overlimit mean?
          </Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              Being overlimit is when your account has gone over the assigned
              credit limit amount. If you are overdue or overlimit you need to
              pay the 'Due immediately' amount straight away.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Item.Header>
            What does minimum payment mean?
          </Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              The minimum payment is the minimum amount you are required to pay
              on your credit card for a particular month, to keep the account up
              to date. Also remember to pay your account by the monthly due date
              to avoid late fees.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Item.Header>
            What does reduce future interest mean?
          </Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              The 'Payment to Reduce Future Interest' amount tells you how much
              you might like to pay that month, to reduce the amount of interest
              you're charged in the future, or in some cases, avoid interest
              altogether. It includes any amounts due, all of your everyday
              purchases, cash advances and balance transfers, plus the balance
              of any 0% interest purchases that are about to expire.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Item.Header>
            What does statement balance mean?
          </Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              The statement balance is the total amount outstanding on your
              account, when your statement is generated. (Note - this does not
              include pending transactions). You can find the date that the
              statement was created under the statement balance amount.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Item.Header>
            What does current balance mean?
          </Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              Current balance is the total amount outstanding on your account at
              this point in time, it does not include pending transactions or
              accrued fees or interest.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Item.Header>
            What are pending transactions?
          </Accordion.Item.Header>
          <Accordion.Item.Content>
            <Text>
              Credit card purchases are immediately deducted from your available
              funds, however they generally take up to 5 days to be processed.
              Until they are processed they appear as pending transactions and
              are not included in the current balance.
            </Text>
          </Accordion.Item.Content>
        </Accordion.Item>
      </Accordion>
    </ShadowContainer>
  );
}

export { WaysToPayFAQ };
